import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Background from '../../components/Background/Background';
import Button from '../../components/Button/Button';
import { partners } from '../../data/partners';
import Header from '../../components/Header/Header';
import './_styles.points.css';
import { useAppDispatch, useAppSelector } from '../../hooks/useApp';
import { getAwards, savePoints } from '../../store/slices/awardsSlice';
import PointsEntry from '../../components/PointsEntry/PointsEntry';

const Points = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { awardPoints } = useAppSelector((state) => state.awards);
  const [currentPoints, setCurrentPoints] = useState(awardPoints);

  const onContinueClick = () => {
    navigate('/choose');
  };

  const onValueChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPoints({
      ...currentPoints,
      [e.target.name]: parseInt(e.target.value.replaceAll(',', '')),
    });
  };

  const updatePartnerPoints = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (value === '') {
      value = '0';
    }

    dispatch(
      savePoints({
        partnerName: e.target.name,
        points: parseInt(value.replaceAll(',', '')),
      })
    );
  };

  useEffect(() => {
    dispatch(getAwards());

    return () => {};
  }, [dispatch]);

  useEffect(() => {
    setCurrentPoints(awardPoints);

    return () => {};
  }, [awardPoints]);

  return (
    <Background image='awards'>
      <Header title='Enter your awards' useBlur />
      <div className='partner-container'>
        {partners.map((p) => (
          <div key={p.group} className='partner-group'>
            <p className='group-title'>{p.group}</p>
            {p.partners.map((partner, index) => (
              <PointsEntry
                index={index}
                partner={partner}
                currentPoints={currentPoints}
                updatePartnerPoints={updatePartnerPoints}
                onValueChanged={onValueChanged}
                key={index}
              />
            ))}
          </div>
        ))}
      </div>
      <div className='w-full mb-16'>
        <Button onClick={onContinueClick}>Continue</Button>
      </div>
    </Background>
  );
};

export default Points;
